import React from 'react';
import HeroSection from './HeroSection';
import AboutSection from './AboutUs';
import TrackApplication from './TrackApplication';
import DepartmentCards from './Stakeholders';
import ImageMarquee from '../components/ImageMarquee';
const HomePage = () => {
  return (
    <div className="min-h-screen no-spacing">
      <style jsx>{`
        .no-spacing > * {
          margin: 0 !important;
        }
        .no-spacing > *:not(:last-child) {
          margin-bottom: 0 !important;
        }
      `}</style>
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* About Section */}
      <AboutSection />
      <ImageMarquee/>
      {/* Track Application Section */}
      <TrackApplication />
      
      {/* Department Cards */}
      <DepartmentCards />
    </div>
  );
};
export default HomePage;